// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"e3915fdf","173":"fc963834","872":"2531d12c","954":"4ee6b2e3"}[chunkId] + ".chunk.js";
};